<template>
  <div>
    <button
      type="button"
      class="btn btn-primary btn-with-addon"
      @click="showModal"
    >
      <span class="btn-addon">
        <i class="btn-addon-icon fe fe-plus-circle" />
      </span>
      Add Hostel
    </button>

    <a-modal v-model="visible" title="Add new hostel">
      <template slot="footer">
        <a-button key="back" @click="handleCancel">Close</a-button>
        <a-button key="submit" type="primary" htmlType="submit" :loading="loading" @click="handleSubmit">Submit</a-button>
      </template>

      <a-form class="mb-4" :form="form">
        <div class="row">
          <div class="col-12 col-md-6">
            <a-form-item label="Hostel Name">
              <a-input
                placeholder="Hostel Name"
                v-decorator="['name', {rules: [{ required: true, message: 'Please input a role name!' }]}]"
              />
            </a-form-item>
          </div>

          <div class="col-12 col-md-6">
            <a-form-item label="Hostel Type">
              <a-select v-decorator="['type', { rules: [{ required: true, message: 'Hostel type is required!!' }] } ]" placeholder="Hostel Type">
                <a-select-option v-for="hostelType in hostelTypes" :value="hostelType.value" :key="hostelType.value">
                  {{ hostelType.name }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </div>
        </div>

        <div class="mb-2">
          <a-form-item label="Description">
            <a-textarea placeholder="Description" :autosize="{minRows: 2}" v-decorator="['description']" />
          </a-form-item>
        </div>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
import { hostelTypes } from '@/services/globaldata'
export default {
  name: 'hostelAddModal',
  props: {
    formVisible: { type: Boolean, require: true },
  },
  data: function() {
    return {
      form: this.$form.createForm(this),
      loading: false,
      visible: false,
      hostelTypes,
    }
  },
  watch: {
    formVisible: function(n, o) {
      this.visible = n
    },
  },
  methods: {
    showModal() {
      this.visible = true
    },
    handleCancel(e) {
      this.visible = false
    },
    handleSubmit(e) {
      this.form.validateFields((err, values) => {
        if (!err) {
          this.$confirm({
            title: `Are you sure you want to add ${values.name}?`,
            content: `Click on the OK button to add the hostel!`,
            onOk: () => {
              this.$nprogress.start()
              this.$http
                .post('/api/hostel/add', {
                  name: values.name,
                  type: values.type,
                  description: values.description,
                })
                .then((data) => {
                  this.visible = false
                  this.$emit('created')
                  this.form.resetFields()
                  this.$nprogress.done()
                  this.$notification['success']({
                    message: 'Hostel successfully added!',
                    description: `Hostel ${values.name} added successfully!`,
                  })
                })
                .catch(error => {
                  this.$nprogress.done()
                  this.$neoNotify.error(error)
                })
            },
            onCancel: () => {
              console.log('Cancel')
            },
          })
        }
      })
    },
  },
}
</script>
